'use client';

import React from 'react';

import Image from 'next/image';
// Using direct public path for SVG

const LoadingSpinner = () => {
  return (
    <div role="status">
      <div className="flex items-center justify-center h-screen z-50 fixed top-0 left-0 w-full bg-gray/50">
        <Image src="/img/logo/LogoDesktop.svg" alt="Logo de Powerbet" width={250} height={90} className="spinner-image" />
      </div>
    </div>
  );
};

export default LoadingSpinner;
